export default "__VITE_ASSET__BSA4cfSC__"